init_select2 = ->
  $('select.select2').select2({})

$(document).ready(init_select2)
$(document).on('turbo:load', init_select2)
